module.exports = __webpack_public_path__ + "5603b46d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/src/src_img/hero_video@2x.png
// module id = 1043
// module chunks = 0